export default __webpack_public_path__ + "static/media/kids.20d94706.jpg";